import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    quickLinks: [
      { name: "Accueil", href: "#home" },
      { name: "À propos", href: "#about" },
      { name: "Projets", href: "#projects" },
      { name: "Contact", href: "#contact" }
    ],
    services: [
      { name: "Développement Web", href: "#services" },
      { name: "Applications Full Stack", href: "#services" },
      { name: "API REST", href: "#services" },
    ],
    social: [
      { 
        name: "LinkedIn", 
        href: "https://www.linkedin.com/in/mostafa-al-mannani", 
        icon: (
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
          </svg>
        )
      },
      { 
        name: "GitHub", 
        href: "https://github.com/MOSTAFA-AL-MANNANI/", 
        icon: (
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd"/>
          </svg>
        )
      },
      { 
        name: "WhatsApp", 
        href: "https://wa.me/212617125803", 
        icon: (
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
          </svg>
        )
      }
    ]
  };

  return (
    <footer className="relative bg-slate-900 overflow-hidden">
      {/* Grid Background matching the App */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background: "#0f172a",
        }}
      />

      {/* Subtle Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -right-20 w-40 h-40 bg-slate-700 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
        <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-slate-600 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse delay-1000"></div>
        <div className="absolute top-1/3 right-1/4 w-32 h-32 bg-slate-500 rounded-full mix-blend-multiply filter blur-xl opacity-15 animate-pulse delay-500"></div>
      </div>

      {/* Floating Particles */}
      <div className="absolute inset-0">
        {React.useMemo(() => 
          [...Array(12)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-slate-400 rounded-full opacity-30 animate-float"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${3 + Math.random() * 2}s`
              }}
            ></div>
          )), [])}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-12 md:py-16 lg:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            
            {/* Brand Section */}
            <div className="lg:col-span-2">
              <div className="mb-8 space-y-6 animate-fade-in">
                <div className="flex items-center gap-4 group cursor-pointer">
                  <div className="w-12 h-12 bg-gradient-to-r from-slate-600 to-slate-500 rounded-xl flex items-center justify-center text-white font-bold text-xl group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <img src="logo.png" alt="Logo" className="w-8 h-8" />
                  </div>
                  <h2 className="text-2xl font-bold text-white group-hover:text-slate-200 transition-colors duration-300">
                    MOSTAFA AL MANNANI
                  </h2>
                </div>
                
                <p className="text-slate-300 text-base leading-relaxed max-w-md hover:text-slate-200 transition-colors duration-300">
                  Expert en développement d'applications web full stack sur mesure. 
                  Création de solutions digitales innovantes pour entreprises et projets personnalisés.
                </p>
              </div>
              
              {/* Contact Info */}
              <div className="space-y-4 animate-fade-in delay-200">
                <div className="flex items-center space-x-3 group">
                  <div className="w-10 h-10 bg-slate-800/50 rounded-lg flex items-center justify-center group-hover:bg-slate-700/50 transition-colors duration-300">
                    <svg className="w-5 h-5 text-slate-300" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                    </svg>
                  </div>
                  <a 
                    href="mailto:mostafaalmannani@gmail.com"
                    className="text-slate-300 hover:text-white transition-all duration-300 text-base group-hover:translate-x-1 transform"
                    aria-label="Envoyer un email"
                  >
                    mostafaalmannani@gmail.com
                  </a>
                </div>
                <div className="flex items-center space-x-3 group">
                  <div className="w-10 h-10 bg-slate-800/50 rounded-lg flex items-center justify-center group-hover:bg-slate-700/50 transition-colors duration-300">
                    <svg className="w-5 h-5 text-slate-300" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                    </svg>
                  </div>
                  <a 
                    href="tel:+212617359379"
                    className="text-slate-300 hover:text-white transition-all duration-300 text-base group-hover:translate-x-1 transform"
                    aria-label="Appeler"
                  >
                    +212 617 125 803
                  </a>
                </div>
                <div className="flex items-center space-x-3 group">
                  <div className="w-10 h-10 bg-slate-800/50 rounded-lg flex items-center justify-center group-hover:bg-slate-700/50 transition-colors duration-300">
                    <svg className="w-5 h-5 text-slate-300" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                    </svg>
                  </div>
                  <span className="text-slate-300 text-base group-hover:text-white transition-colors duration-300">
                    Casablanca, Maroc
                  </span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="animate-fade-in delay-300">
              <h4 className="text-xl font-semibold text-white mb-6 group">
                <span className="border-b-2 border-slate-500 pb-2 group-hover:border-slate-300 transition-colors duration-300">
                  Navigation
                </span>
              </h4>
              <ul className="space-y-3">
                {footerLinks.quickLinks.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.href}
                      className="text-slate-300 hover:text-white transition-all duration-300 text-base block hover:translate-x-2 transform group"
                    >
                      <span className="flex items-center space-x-2">
                        <div className="w-1.5 h-1.5 bg-slate-500 rounded-full group-hover:bg-slate-300 transition-colors duration-300"></div>
                        <span>{link.name}</span>
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services & Social */}
            <div className="animate-fade-in delay-400">
              <div className="mb-8">
                <h4 className="text-xl font-semibold text-white mb-6 group">
                  <span className="border-b-2 border-slate-500 pb-2 group-hover:border-slate-300 transition-colors duration-300">
                    Services
                  </span>
                </h4>
                <ul className="space-y-3">
                  {footerLinks.services.map((service, index) => (
                    <li key={index}>
                      <a 
                        href={service.href}
                        className="text-slate-300 hover:text-white transition-all duration-300 text-base block hover:translate-x-2 transform group"
                      >
                        <span className="flex items-center space-x-2">
                          <div className="w-1.5 h-1.5 bg-slate-500 rounded-full group-hover:bg-slate-300 transition-colors duration-300"></div>
                          <span>{service.name}</span>
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              
              {/* Social Links */}
              <div>
                <h4 className="text-xl font-semibold text-white mb-6 group">
                  <span className="border-b-2 border-slate-500 pb-2 group-hover:border-slate-300 transition-colors duration-300">
                    Réseaux sociaux
                  </span>
                </h4>
                <div className="flex space-x-4">
                  {footerLinks.social.map((social, index) => (
                    <a 
                      key={index}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 bg-slate-800/50 hover:bg-slate-700/70 rounded-xl flex items-center justify-center text-slate-300 hover:text-white transition-all duration-300 transform hover:scale-110 hover:-translate-y-1 shadow-lg hover:shadow-xl"
                      aria-label={`Suivre sur ${social.name}`}
                    >
                      {social.icon}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700/50 py-6 md:py-8 animate-fade-in delay-500">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-center md:text-left">
              <p className="text-slate-400 text-base hover:text-slate-300 transition-colors duration-300">
                © {currentYear} Mostafa Al Mannani. Tous droits réservés.
              </p>
            </div>

            {/* Additional Links */}
            <div className="flex flex-wrap justify-center md:justify-end space-x-4 md:space-x-6">
              <span className="text-slate-500 text-base cursor-not-allowed hover:text-slate-400 transition-colors duration-300">
                Politique de confidentialité
              </span>
              <span className="text-slate-500 text-base cursor-not-allowed hover:text-slate-400 transition-colors duration-300">
                Mentions légales
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <div className="absolute bottom-6 right-6 animate-fade-in delay-700">
        <button 
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="w-12 h-12 md:w-14 md:h-14 bg-slate-800/70 hover:bg-slate-700/80 backdrop-blur-sm rounded-full flex items-center justify-center text-slate-300 hover:text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 hover:-translate-y-1 border border-slate-600/50 hover:border-slate-400/50"
          aria-label="Retour en haut de la page"
        >
          <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
        </button>
      </div>
    </footer>
  );
};

export default Footer;